import { jsx as _jsx } from "react/jsx-runtime";
import { ScriptType } from '@glomex/integration-web-component';
/**
 * React component to define a glomex media item.
 */
export const GlomexMediaItemReact = (item) => {
    const { id: mediaItemId, overrides: mediaItemOverrides } = item;
    return (_jsx("glomex-media-item", { id: mediaItemId, title: mediaItemOverrides?.title, poster: mediaItemOverrides?.poster, children: _jsx("script", { type: ScriptType.EXTERNAL_MEDIA_ITEM, children: JSON.stringify(mediaItemOverrides || {}) }) }));
};
